import React from 'react';
import { ReactEditor } from 'slate-react';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import classnames from 'classnames';
import { type ToolbarSubmenuProps } from '../../../types/aha-editor';
import type ToolMark from '../../Formatting/tools/ToolMark';
import BlockUtils from '../../Blocks/BlockUtils';
import { isCommonBlockElement } from '../../../types/guards';

interface LineHeight {
  displayName: string;
  styleName: string;
}

const LINE_HEIGHT_LIST: LineHeight[] = [
  { displayName: 'Single', styleName: '1' },
  { displayName: '1.15', styleName: '1.15' },
  { displayName: '1.3', styleName: '1.35' },
  { displayName: '1.5', styleName: '1.5' },
  { displayName: 'Double', styleName: '2' },
];

const LineHeightPicker: React.FC<ToolbarSubmenuProps<typeof ToolMark>> = ({
  editor,
  controller,
  tool,
  isSubmenu,
}) => {
  let currentLineHeight: string | undefined;
  const currentBlock = BlockUtils.currentBlock(editor);
  if (
    currentBlock &&
    isCommonBlockElement(currentBlock[0]) &&
    currentBlock[0].lineHeight
  ) {
    currentLineHeight = currentBlock[0].lineHeight;
  }

  const handleLineHeightChange = (lineHeight: LineHeight) => {
    tool.action({ editor, controller, lineHeight: lineHeight.styleName });
    ReactEditor.focus(editor);
  };

  return (
    <aha-menu submenu={isSubmenu}>
      <div
        slot="control"
        className={classnames({
          [styles.toolbarButtonDisabled]: !tool.isEnabled({
            editor,
            controller,
          }),
        })}
      >
        <i className={classnames('fa-fw', tool.iconClass)} />
        {isSubmenu && tool.label}
      </div>
      <aha-menu-content>
        {LINE_HEIGHT_LIST.map((lineHeight) => (
          <aha-menu-item
            key={`line-height-${lineHeight.displayName}`}
            selected={lineHeight.styleName === currentLineHeight ? true : null}
            onClick={() => handleLineHeightChange(lineHeight)}
          >
            <div style={{ padding: '6px 8px' }}>{lineHeight.displayName}</div>
          </aha-menu-item>
        ))}
      </aha-menu-content>
    </aha-menu>
  );
};

export default LineHeightPicker;
